(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const roots = document.querySelectorAll('[data-tabs-root]');
    roots.forEach((root) => {
      const tabs = () => Array.from(root.querySelectorAll('.tabs__tab[role="tab"]'));
      const panelFor = (i) => root.querySelector(`[data-tab-panel="${i}"]`);

      const activate = (index) => {
        const t = tabs();
        t.forEach((tab, i) => {
          const on = i === index;
          tab.classList.toggle('tabs__tab--active', on);
          tab.setAttribute('aria-selected', on ? 'true' : 'false');
          tab.tabIndex = on ? 0 : -1;
          const panel = panelFor(i);
          if (panel) {
            if (on) {
              panel.removeAttribute('hidden');
              panel.classList.add('tabs__panel--active');
            } else {
              panel.setAttribute('hidden', '');
              panel.classList.remove('tabs__panel--active');
            }
          }
        });
      };

      root.addEventListener('click', (e) => {
        const btn = e.target.closest('.tabs__tab');
        if (!btn || !root.contains(btn)) return;
        const idx = Number(btn.getAttribute('data-tab-index'));
        if (Number.isNaN(idx)) return;
        activate(idx);
      });

      root.addEventListener('keydown', (e) => {
        const btn = e.target.closest('.tabs__tab');
        if (!btn || !root.contains(btn)) return;
        const list = tabs();
        const cur = list.indexOf(btn);
        if (cur < 0) return;
        let next = cur;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
          e.preventDefault();
          next = (cur + 1) % list.length;
        } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
          e.preventDefault();
          next = (cur - 1 + list.length) % list.length;
        } else if (e.key === 'Home') {
          e.preventDefault();
          next = 0;
        } else if (e.key === 'End') {
          e.preventDefault();
          next = list.length - 1;
        } else {
          return;
        }
        activate(next);
        list[next].focus();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vdb-setting-pdp"]) return;
  try {
    
  var loadProductRecommendationsIntoSection = function () {
    var section = document.querySelector('.product-recommendations');
    if (!section) return;

    var request = new XMLHttpRequest();
    request.open('GET', section.dataset.url);
    request.onload = function () {
      if (request.status >= 200 && request.status < 300) {
        var container = document.createElement('div');
        container.innerHTML = request.response;
        var newSection = container.querySelector('.product-recommendations');
        if (newSection) {
          section.innerHTML = newSection.innerHTML;
        }
      }
    };
    request.send();
  };

  document.addEventListener('shopify:section:load', function (event) {
    if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
      loadProductRecommendationsIntoSection();
    }
  });

  loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
